module.exports = __webpack_public_path__ + "static/media/envios.13c118b0.gif";